
(function () {
  'use strict';

  const SELECTOR_GROUP = '.custom-swiper-buttons';
  const CLASS_BTN      = 'x-swiper-button';
  const CLASS_PREV     = 'x-swiper-button-prev';
  const CLASS_NEXT     = 'x-swiper-button-next';
  const CLASS_DISABLED = 'disabled';

  const GAP_FALLBACK = 24; // запас на межколоночный зазор, если не удастся вычислить

  function qsAll(root, sel) { try { return Array.from((root || document).querySelectorAll(sel)); } catch(e){ return []; } }

  function getTargetsFromGroup(groupEl) {
    const sel = groupEl?.dataset?.target || groupEl?.dataset?.taget || groupEl?.getAttribute('data-target') || groupEl?.getAttribute('data-traget');
    if (!sel) return [];
    return qsAll(document, sel);
  }

  function getSwiperFor(el) {
    // 1) если target сам является .swiper или ему присвоен swiper-инстанс
    if (el && el.swiper) return el.swiper;
    // 2) если внутри есть .swiper (некоторые темы оборачивают .swiper на уровень ниже)
    const inside = el?.querySelector?.('.swiper');
    if (inside && inside.swiper) return inside.swiper;
    // 3) если target находится внутри .swiper
    const closest = el?.closest?.('.swiper');
    if (closest && closest.swiper) return closest.swiper;
    return null;
  }

  function computeStep(container) {
    // Берём ширину первого айтема как шаг перелистывания
    const item = container.querySelector('.x-collection-card, .swiper-slide, [role="listitem"], .x-cell, * > *');
    if (!item) return container.clientWidth || 320;
    const rect = item.getBoundingClientRect();
    let gap = GAP_FALLBACK;

    // Попробуем вытащить CSS gap из инлайн-стилей CSS-переменных
    const styles = getComputedStyle(container);
    const cg = parseFloat(styles.columnGap) || parseFloat(styles.gap);
    if (!isNaN(cg) && cg > 0) gap = cg;

    return Math.ceil(rect.width + gap);
  }

  function canScrollMore(container, dir) {
    if (!container) return false;
    const max = container.scrollWidth - container.clientWidth - 1; // -1 на погрешности
    if (dir < 0) return container.scrollLeft > 0;
    return container.scrollLeft < max;
  }

  function updateDisabled(groupEl, container) {
    const prev = groupEl.querySelector('.' + CLASS_PREV);
    const next = groupEl.querySelector('.' + CLASS_NEXT);
    if (!container) return;

    const atStart = container.scrollLeft <= 0;
    const atEnd   = container.scrollLeft >= container.scrollWidth - container.clientWidth - 1;

    if (prev) prev.classList.toggle(CLASS_DISABLED, atStart);
    if (next) next.classList.toggle(CLASS_DISABLED, atEnd);
  }

  function smoothScroll(container, delta) {
    container.scrollBy({ left: delta, behavior: 'smooth' });
  }

  function attachHandlersToGroup(groupEl) {
    const targets = getTargetsFromGroup(groupEl);
    if (targets.length === 0) return;

    const btnPrev = groupEl.querySelector('.' + CLASS_PREV);
    const btnNext = groupEl.querySelector('.' + CLASS_NEXT);

    function handle(dir) {
      targets.forEach(target => {
        const swiper = getSwiperFor(target);

        if (swiper) {
          // Управляем Swiper напрямую
          if (dir < 0) swiper.slidePrev(); else swiper.slideNext();
          // Обновим disabled у кнопок (Swiper может перекинуть нас в начало/конец)
          setTimeout(() => {
            try {
              const isFirst = swiper.isBeginning;
              const isLast  = swiper.isEnd;
              if (btnPrev) btnPrev.classList.toggle(CLASS_DISABLED, isFirst);
              if (btnNext) btnNext.classList.toggle(CLASS_DISABLED, isLast);
            } catch(e){}
          }, 20);
          return;
        }

        // Fallback: горизонтальный скролл контейнера-решётки
        const scrollHost =
          target.matches('.swiper, .swiper-wrapper') ? target :
          target; // ваш .collection-list__grid и так является нужным хостом

        const step = computeStep(scrollHost);
        const delta = dir < 0 ? -step : step;

        // Проверим, есть ли куда скроллить; если нет — обновим disabled
        if (!canScrollMore(scrollHost, dir)) {
          updateDisabled(groupEl, scrollHost);
          return;
        }

        smoothScroll(scrollHost, delta);

        // Обновим disabled чуть позже, когда scrollLeft изменится
        setTimeout(() => updateDisabled(groupEl, scrollHost), 200);
      });
    }

    if (btnPrev) btnPrev.addEventListener('click', (e) => { e.preventDefault(); if (!btnPrev.classList.contains(CLASS_DISABLED)) handle(-1); });
    if (btnNext) btnNext.addEventListener('click', (e) => { e.preventDefault(); if (!btnNext.classList.contains(CLASS_DISABLED)) handle(1); });

    // Инициализационное выставление disabled для fallback-скролла
    targets.forEach(t => {
      const swiper = getSwiperFor(t);
      if (!swiper) {
        updateDisabled(groupEl, t);
        // Следим за ресайзом, чтобы корректно обновлять состояние
        let ro;
        if ('ResizeObserver' in window) {
          ro = new ResizeObserver(() => updateDisabled(groupEl, t));
          ro.observe(t);
        }
        t.addEventListener('scroll', () => updateDisabled(groupEl, t), { passive: true });
      } else {
        // Если это Swiper — подписываемся на его события
        swiper.on('slideChange', () => {
          if (btnPrev) btnPrev.classList.toggle(CLASS_DISABLED, swiper.isBeginning);
          if (btnNext) btnNext.classList.toggle(CLASS_DISABLED, swiper.isEnd);
        });
        // стартовое состояние
        if (btnPrev) btnPrev.classList.toggle(CLASS_DISABLED, swiper.isBeginning);
        if (btnNext) btnNext.classList.toggle(CLASS_DISABLED, swiper.isEnd);
      }
    });
  }

  function init(root) {
    qsAll(root || document, SELECTOR_GROUP).forEach(attachHandlersToGroup);
  }

  // Инициализация на готовом DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Если блоки подгружаются динамически (Shopify/темы часто так делают)
  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches(SELECTOR_GROUP)) {
          attachHandlersToGroup(node);
        } else {
          const inside = node.querySelectorAll ? node.querySelectorAll(SELECTOR_GROUP) : [];
          inside && inside.forEach(el => attachHandlersToGroup(el));
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

})();
